import { postData } from "../Ops";
export class DashboardWidgetService {
  fetch = async (type = "count", query: any) => {
    const queryData = JSON.stringify(query);
    const formData = new FormData();
    formData.append("query", queryData);
    return await postData(`dashboardWidget/${type}/get`, formData);
  };
}
